import React from "react";
import ReactModal from "react-modal";
import { axiosget, axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import CryptoJS from "crypto-js";
import { APIKEY, MerchantId, ServiceTypeId } from "../../components/Keys";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import is_money from "../../helpers/is_money";
import { contextapi } from "../../helpers/contextapi";
import Swal from "sweetalert2";

const BtnGenerateRRR = () => {
  const [showmodal, setshowmodal] = React.useState(false);
  const [program, setprogram] = React.useState(false);
  const context = React.useContext(contextapi);
  const queryClient = useQueryClient();
  const { user } = context.values;
  const _show = () => {
    setshowmodal(true);
  };
  const { data } = useQuery({
    queryKey: ["paymentProgramList"],
    queryFn: async () => {
      const req = await axiosget("ms_programme");
      return req?.data;
    },
  });

  const {
    data: table,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["paymentCost", program],
    queryFn: async () => {
      const req = await axiosget(`ms_application_fee_items/${program}`);
      return req?.data;
    },
    enabled: !!program,
  });
  let amount = 0;
  if (!error && table?.type === undefined) amount = table?.map((v) => v.amount).reduce((p, a) => p + a, 0);

  const _generateRRR = async () => {
    try {
      const serviceTypeId = ServiceTypeId;
      const d = new Date();
      const orderId = d.getTime();
      const merchantId = MerchantId;
      const apiKey = APIKEY;

      const course = data?.filter((r) => r._id === program)?.shift();

      var apiHash = CryptoJS.SHA512(merchantId + serviceTypeId + orderId + amount + apiKey);
      const dataRRR = {
        serviceTypeId: serviceTypeId,
        amount: amount,
        orderId: orderId,
        payerName: `${user.firstname} ${user.middlename}  ${user.lastname}`,
        payerEmail: user?.emailaddress,
        payerPhone: user?.phonenumber,
        description: `${user?.emailaddress} remita payment to apply for: ${course?.code} ${course.name}`,
      };

      const headerRRR = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `remitaConsumerKey=${merchantId},remitaConsumerToken=${apiHash}`,
        },
        method: "POST",
        body: JSON.stringify(dataRRR),
      };

      fetch("https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/merchant/api/paymentinit", headerRRR)
        .then((r) => r.text())
        .then(async (r) => {
          const removeF = JSON.parse(r.substring(r.indexOf("{"), r.lastIndexOf("}") + 1));
          if (removeF?.RRR === undefined) {
            swal("error", `Remita error: ${removeF.status}`);
            return;
          }
          const fetch = await axiospost("ms_application_fee", {
            programme: course?._id,
            rrr: removeF.RRR,
            data: dataRRR,
          });
          if (fetch?.status !== 200) {
            swal("error", "Sorry, system could not store your RRR Code, please try and generate another RRR code");
            return;
          }
          if (fetch?.data?.type === "error") {
            swal("error", fetch?.data?.message);
            return;
          }
          queryClient.invalidateQueries({ queryKey: ["generatedRRR"] });
          Swal.fire({
            icon: "info",
            title: `PAYMENT RRR`,
            html: `Kindly copy your remita transaction id<br/><h1>${removeF.RRR}</h1>`,
          });
        });
    } catch ({ message }) {
      swal("error", message);
    }
  };
  return (
    <div>
      <ReactModal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-uppercase">Generate Remita RRR For Payment</h5>
              <span className="pointer text-danger" onClick={() => setshowmodal(false)}>
                x
              </span>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group form-floating">
                    <select onChange={(e) => setprogram(e.target.value)} name="examinationtype" id="" className={`form-control form-control-lg`}>
                      <option value="">Select Option</option>
                      {data?.map((r, i) => (
                        <option key={`list_of_courses_for_payment_${i}`} value={r?._id}>{`${r.code} - ${r.name}`}</option>
                      ))}
                    </select>
                    <label htmlFor="firstname">Select program you are applying for</label>
                  </div>
                </div>
                <div className="col-md-12">{isLoading && <Loader />}</div>
                <div className="col-md-12">{error && <ErrorResponse type={"danger"} title="Error encountered" message={error} />}</div>
                <div className="col-md-12">
                  {table?.type !== undefined && <ErrorResponse type={"info"} title="Error encountered" message={table?.message} />}
                </div>
                <div className="col-md-12">
                  {table && table?.type === undefined && (
                    <>
                      <table className="table table-hover table-stripe">
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Title</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {table?.map((r, i) => (
                            <tr key={`payment_items_${i}${r?._id}`}>
                              <th>{i + 1}</th>
                              <td>{r.name}</td>
                              <td>{is_money(r.amount)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mt-3">
                        <button onClick={_generateRRR} className="btn btn-lg btn-primary btn-block">
                          Generate RRR Code For {is_money(amount)}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
      <div>
        <div
          style={{
            position: "fixed",
            right: "50px",
            bottom: "50px",
          }}
        >
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="ti-plus"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BtnGenerateRRR;
